// eslint-disable-next-line import/prefer-default-export
export function isAbsoluteUrl(url) {
  return url.match(/^(http:\/\/|https:\/\/)/i);
}

export function makeAbsoluteUrl(url, prefix) {
  if (isAbsoluteUrl(url)) {
    return url;
  }

  return `${prefix.replace(/\/$/i, '')}/${url.replace(/^\//i, '')}`;
}

export function sanitizeIdParameter(str) {
  const regex = /[^a-z0-9-]/gi;
  return str.replaceAll(regex, '');
}

export function urlByContentType(type, args = {}) {
  switch (type) {
    case 'ContentfulArticle':
    case 'ContentfulMultimedia':
      return `/articles/${args.slug}`;
    case 'ContentfulAsk':
      return `/ask-me-anything/${args.slug}`;
    case 'ContentfulMeetup':
      return `/meetups/${args.slug}`;
    default:
      return null;
  }
}

export const authUrls = ['/sign-up', '/sign-in', '/sign-in-clever', '/sign-in-clever-redirect'];

/**
 * Trim trailing slashes
 *
 * @param {string} url
 * @return string
 */
export function trimTrailingSlash(url) {
  return typeof url === 'string' ? url.replace(/\/+$/, '') : url;
}

/**
 * Is auth (sign-in, sign-up) URL
 * Typically used identify URLs specifically related to authentication to include/exclude functionality
 *
 * @param {string} url
 */
export function isAuthUrl(url) {
  return authUrls.indexOf(trimTrailingSlash(url)) !== -1;
}
